import { NgModule } from '@angular/core';

import { AvSwitchComponent } from './switch';

@NgModule({
  imports: [],
  exports: [ AvSwitchComponent ],
  declarations: [ AvSwitchComponent ],
  providers: [],
})
export class AvSwitchModule { }
